/**
 * Champion identity of a legend print ("Darius"), not its title
 * ("Darius, Hand of Noxus"). Shared by the deck builder and the publish API.
 */

export function foldLegendIdentity(value) {
  return String(value ?? '').toLowerCase().replace(/['’‘‛]/g, "'").trim();
}

export function championIdentityFromName(name) {
  const s = String(name ?? '').trim();
  if (!s) return '';
  const head = s.split(/,|\s[-–—]\s/)[0].trim();
  if (head !== s) return foldLegendIdentity(head);
  return foldLegendIdentity(head.split(/\s+/)[0] || head);
}

/** Champion identity for a legend print. Same rule as the legend picker. */
export function legendIdentityFromRef(ref) {
  const champion = ref?.champion?.trim();
  if (champion) return foldLegendIdentity(champion);
  const name = ref?.name?.trim();
  return name ? championIdentityFromName(name) : '';
}
